import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text, Stack, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { STEPS_COUNT } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/LLMSetupConst";

interface ILLMSetupHeaderProps {
    currentStep: number;
}

export const LLMSetupHeader = ({ currentStep }: ILLMSetupHeaderProps) => (
    <Flex
        flexDirection="column"
        padding="24px"
    >
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[300]}
            data-automation="llm-setup-title-page"
        >
            {translate("llm.setup.modal.title.step", {
                current: currentStep,
                total: STEPS_COUNT,
            })}
        </Text>
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
                data-automation="llm-setup-title"
            >
                {translate("llm.setup.modal.title")}
            </Text>
            <Tooltip
                content={
                    <Stack>
                        <Text
                            fontVariant="tooltip"
                            maxWidth="250px"
                        >
                            {translate("llm.setup.modal.title.tooltip")}
                        </Text>
                    </Stack>
                }
            >
                <SWReactIcons
                    iconName="info"
                    iconColor={colorsPalettes.carbon[200]}
                    size="xs"
                />
            </Tooltip>
        </Flex>
    </Flex>
);
